<!--
 * @Descripttion: 注册页面组件(短信验证码注册)
 * @Author: congz
 * @Date: 2020-06-11 10:01:19
-->
<template>
  <div class="register">
    <div>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>Register</span>
        </div>
        <div class="item">
          <el-form :model="otpForm" status-icon :rules="otpRules" ref="otpForm">
            <el-form-item prop="phone">
              <el-input v-model="otpForm.phone" placeholder="Phone Number (10 digits)" maxlength="10"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="otpForm.code" placeholder="6-digit verification code" maxlength="6">
                <el-button
                  slot="append"
                  @click="sendCode"
                  :disabled="cannotClick"
                >{{content}}</el-button>
              </el-input>
            </el-form-item>
            <el-form-item>
              <div class="math-captcha">
                <span class="math-expression" @click="refreshCaptcha">{{ captcha.expression }}</span>
                <el-input v-model="captcha.value" placeholder="Answer"></el-input>
              </div>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="register('otpForm')">Register</a>
          </div>
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">Already have an account? Log in directly></el-link>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Register',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your phone number'))
      } else if (!/^[0-9]{10}$/.test(value)) {
        callback(new Error('Please enter a 10-digit phone number'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter the verification code'))
      } else if (!/^[0-9]{6}$/.test(value)) {
        callback(new Error('Please enter a 6-digit verification code'))
      }
      callback()
    }
    return {
      otpForm: {
        phone: '',
        code: ''
      },
      otpRules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      captcha: {
        id: '',
        expression: '',
        value: ''
      },
      content: 'Send Code',
      cannotClick: false,
      totalTime: 60
    }
  },
  methods: {
    ...mapActions(['setUser']),
    register(formName) {
      var self = this
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        if (self.captcha.value === '') {
          self.notifyError('Please answer the math question', null)
          return
        }
        // 短信验证码登录/注册接口:手机号不存在时自动创建账号
        userAPI
          .smsLogin({
            phone: self.otpForm.phone,
            code: self.otpForm.code
          })
          .then(res => {
            if (res.status === 200) {
              // 注册成功自动登录:写入本地存储和vuex
              localStorage.setItem('user', JSON.stringify(res.data.user))
              localStorage.setItem('token', res.data.token)
              self.setUser(res.data.user)
              self.notifySucceed('Registered successfully')
              self.$router.push({
                name: 'Home'
              })
            } else {
              self.notifyError('Registration failed', res.msg)
            }
          })
          .catch(error => {
            self.notifyError('Registration failed', error)
          })
      })
    },
    // 倒计时
    countDown() {
      var self = this
      if (self.cannotClick) return
      self.cannotClick = true
      self.content = self.totalTime + 's'
      var clock = window.setInterval(function() {
        self.totalTime--
        self.content = self.totalTime + 's'
        if (self.totalTime < 0) {
          window.clearInterval(clock)
          self.content = 'Send Code'
          self.totalTime = 60
          self.cannotClick = false
        }
      }, 1000)
    },
    // 发送短信验证码(需算式验证码前置校验)
    sendCode() {
      var self = this
      if (self.cannotClick) {
        return
      }
      if (self.otpForm.phone === '') {
        self.notifyError('Please enter your phone number', null)
        return
      }
      if (self.captcha.value === '') {
        self.notifyError('Please answer the math question', null)
        return
      }
      var form = {
        phone: self.otpForm.phone,
        captcha_id: self.captcha.id,
        captcha_value: self.captcha.value
      }
      userAPI
        .sendSMSCode(form)
        .then(res => {
          if (res.status === 200) {
            self.countDown()
            self.captcha.value = ''
            self.refreshCaptcha()
            self.notifySucceed('Verification code sent')
          } else {
            self.refreshCaptcha()
            self.captcha.value = ''
            self.notifyError('Failed to send code', res.msg)
          }
        })
        .catch(error => {
          self.refreshCaptcha()
          self.captcha.value = ''
          self.notifyError('Failed to send code', error)
        })
    },
    // 刷新算式验证码
    refreshCaptcha() {
      var self = this
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200) {
          self.captcha.id = res.data.captcha_id
          self.captcha.expression = res.data.expression
        }
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
}

.math-captcha {
  display: flex;
  align-items: center;
  width: 100%;
}

.math-expression {
  min-width: 110px;
  height: 40px;
  line-height: 40px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin-right: 8px;
  font-size: 16px;
  font-weight: bold;
  color: #8B5A2B;
  cursor: pointer;
  user-select: none;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}
</style>
